(function($) {
  checkReview(0);

  function checkReview(c) {
    setTimeout(() => {
      if ($('.ProductItem__Info .yotpo.bottomLine .yotpo-bottomline .yotpo-stars').length) {
        $('.ProductItem__Info .yotpo.bottomLine .yotpo-bottomline a').each(function() {
          var text = $(this).text();
          var textOld = text.replace(" Reviews", "").replace(" Review", "");
          text = $(this).text(textOld)
        })
      } else { 
        checkReview(c + 1)
      };
    }, 1000);
  }
  
})(jQuery);